import { supabase } from '@/integrations/supabase/client';

export const supportAPI = {
  // Send a support request
  async sendSupportRequest(name: string, email: string, message: string, userId?: string) {
    // This should match the schema for the support form
    const supportData = {
      name,
      email,
      message,
      user_id: userId,
      created_at: new Date().toISOString(),
      status: 'new',
    };

    try {
      // Store the support request in the database
      const { data, error } = await supabase
        .from('support_requests')
        .insert([supportData]);
      
      if (error) {
        throw error;
      }

      // If you also want to send an email notification
      // This would normally call a serverless function or backend service
      // that sends an email to your support team
      if (import.meta.env.PROD) {
        try {
          const webhookUrl = import.meta.env.VITE_SUPPORT_EMAIL_WEBHOOK;
          if (webhookUrl) {
            await fetch(webhookUrl, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(supportData),
            });
          }
        } catch (emailError) {
          // Log email sending error but don't fail the whole operation
          
        }
      }

      return { success: true };
    } catch (error) {
      
      return { success: false, error };
    }
  }
}; 